import type { TeacherVM } from "@shared-kernel/application/ports/student/student-repository";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveTeachers = createApiThunk<TeacherVM[], void>(
  "teachers/retrieveTeachers",
  async (_: void, { extra: { studentRepository } }) => {
    return studentRepository!.teacherList();
  },
);
